/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Add_Another_Liable_VehicleInputs */

const en_case_add_another_liable_vehicle = /** @type {(inputs: Case_Add_Another_Liable_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another vehicle`)
};

const pt_br2_case_add_another_liable_vehicle = /** @type {(inputs: Case_Add_Another_Liable_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar outro veículo`)
};

/**
* | output |
* | --- |
* | "Add another vehicle" |
*
* @param {Case_Add_Another_Liable_VehicleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_add_another_liable_vehicle = /** @type {((inputs?: Case_Add_Another_Liable_VehicleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Add_Another_Liable_VehicleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_add_another_liable_vehicle(inputs)
	return pt_br2_case_add_another_liable_vehicle(inputs)
});